
import React, { useEffect, useState } from 'react'
import { Row, Col } from 'antd'


//导入样式
import '@/scss/common.scss'



//mobx
import { useStore } from '@/store'
import { observer } from 'mobx-react-lite'
import { toJS } from 'mobx'
import Edit from "./copy"
const App = () => {
    //mobx
    const { DeviceStore } = useStore()

    const searchParams = new URLSearchParams(window.location.search)
    const DevCode = searchParams.get('DevCode')

    // console.log(DeviceStore.DevCode, "00", DevCode)
    useEffect(() => {
        DeviceStore.setPage(DevCode)
        // eslint-disable-next-line
    }, [])


    return (
        <>
            <Row>
                {
                    toJS(DeviceStore.Datashow).length > 0 ? (
                        toJS(DeviceStore.Datashow).map((item, index) => (
                            (!item.NotShow && DeviceStore.type.indexOf(item.DisplayType) > -1) ? (
                                <>
                                    <Col span={6} key={index}>
                                        <Edit value={item} code={DeviceStore.DevCode} index={index} />
                                    </Col>
                                </>
                            )
                                : (''))
                        )) : ('暂无数据')
                }
            </Row>
        </>
    )
}

export default observer(App)